export default "__VITE_ASSET__a06286d0__"